
import React from 'react';
import { FileText } from 'lucide-react';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';

interface ScheduleNotesFieldProps {
  notes: string;
  setNotes: (value: string) => void;
}

const ScheduleNotesField: React.FC<ScheduleNotesFieldProps> = ({
  notes,
  setNotes,
}) => {
  return (
    <div>
      <Label htmlFor="notes" className="text-sm font-medium">
        <FileText className="inline-block h-4 w-4 mr-2" />
        Notes
      </Label>
      <Textarea id="notes" value={notes} onChange={(e) => setNotes(e.target.value)} />
    </div>
  );
};

export default ScheduleNotesField;
